export default __webpack_public_path__ + "static/media/helpful-resources-page--desktop.719ea21c.webp";